import { useTranslation } from "react-i18next";
import { CategoryChip } from "./CategoryChip";

export interface CategoryChipsProps {
  categories: readonly string[];
  /** `null` = "Todos". */
  selected: string | null;
  onSelect: (category: string | null) => void;
}

/**
 * La fila de chips de categoría, con "Todos" al frente.
 *
 * Pulsar el chip que ya está puesto lo QUITA: es la salida evidente del
 * filtro, sin tener que buscar el "Todos" al otro lado de la fila.
 *
 * Los nombres de las categorías NO pasan por `t()`: son datos del
 * catálogo, escritos por quien lo administra. Traducirlos aquí exigiría
 * un despliegue cada vez que se inventa una categoría nueva.
 */
export function CategoryChips({ categories, selected, onSelect }: CategoryChipsProps) {
  const { t } = useTranslation();

  return (
    <div
      role="group"
      aria-label={t("Filtrar por categoría")}
      className="flex flex-wrap items-center gap-2"
    >
      <CategoryChip
        label={t("Todos")}
        selected={selected === null}
        onClick={() => onSelect(null)}
      />
      {categories.map((category) => (
        <CategoryChip
          key={category}
          label={category}
          selected={selected === category}
          onClick={() => onSelect(selected === category ? null : category)}
        />
      ))}
    </div>
  );
}
